module.exports = __webpack_public_path__ + "img/bg-catracas.a15d5329.jpeg";